export default __webpack_public_path__ + "static/media/power.61b100a2.gif";